import React, { useState } from "react";
import Icon from "@mdi/react";
import { mdiPlus } from "@mdi/js";

const Faq = ({ items }) => {
  const [open, setOpen] = useState(0);
  if (!items?.length) return null;
  return (
    <div className="faq">
      {items.map((it, i) => (
        <div className="faq__item" key={it.q}>
          <button
            className="faq__q"
            aria-expanded={open === i}
            onClick={() => setOpen(open === i ? -1 : i)}
          >
            {it.q}
            <Icon path={mdiPlus} />
          </button>
          {open === i && <div className="faq__a">{it.a}</div>}
        </div>
      ))}
    </div>
  );
};

export default Faq;

export const faqJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((it) => ({
    "@type": "Question",
    name: it.q,
    acceptedAnswer: { "@type": "Answer", text: it.a },
  })),
});
